<template>
  <div>
    <div class="myspinner">
      <atom-spinner
        v-if="loading"
        :animation-duration="speed"
        :size="config.size"
        :color="spinnersColor"
      />
    </div>
    <form @submit.prevent="showOTP ? submitFinal() : onsubmit()">
      <va-input
        v-model="form.memb_no"
        type="text"
        :label="$t('auth.memb_no')"
        :error="!!membNoErrors.length"
        :error-messages="membNoErrors"
        @keydown="nameKeydown($event)"
      />

      <va-input
        v-model="form.id_no"
        type="number"
        :label="$t('auth.id_no')"
        :error="!!idNoErrors.length"
        :error-messages="idNoErrors"
      />

      <va-input
        v-model="form.phone_no"
        type="number"
        @input=validatephone
        :label="$t('auth.phone_no')"
        :error="!!phoneNoErrors.length"
        :error-messages="phoneNoErrors"
      />

      <!-- <va-input
        v-model="form.email"
        type="email"
        :label="$t('auth.email')"
        :error="!!emailErrors.length"
        :error-messages="emailErrors"
      /> -->

      <va-input
        v-model="form.password"
        type="password"
        :label="$t('auth.password')"
        :error="!!passwordErrors.length"
        :error-messages="passwordErrors"
        @input = "checklength"
      />

      <va-input
        v-model="form.confirmpassword"
        type="password"
        :label="$t('auth.confirm-password')"
        :error="!!confirmPasswordErrors.length"
        :error-messages="confirmPasswordErrors"
      />

      <va-input
        v-if="showOTP"
        v-model="form.otp"
        type="text"
        :label="$t('auth.otp')"
        :error="!!otpErrors.length"
        :error-messages="otpErrors"
      />

      <div class="auth-layout__options d-flex align--center justify--space-between">
        <va-checkbox
          v-model="form.agreedToTerms"
          class="mb-0"
          :error="!!agreedToTermsErrors.length"
          :errorMessages="agreedToTermsErrors"
        >
          <template slot="label">
            {{ $t('auth.agree') }}
            <a href="#" class="link" target="_blank">{{ $t('auth.termsOfUse') }}</a>
          </template>
        </va-checkbox>
        <router-link class="ml-1 link" :to="{name: 'recover-password'}">
          {{$t('auth.recover_password')}}
        </router-link>
      </div>

      <div class="d-flex justify--center mt-3">
        <va-button v-if="!showOTP" type="submit" :disabled="disableButton" class="my-0">{{ $t('auth.sign_up') }}</va-button>
        <va-button v-if="showOTP" type="submit"  :disabled="disableButton"  class="my-0">{{ $t('auth.validate') }}</va-button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios'
import * as spinners from 'epic-spinners'

export default {
  components: {
    ...spinners      
  },
  name: 'signup',
  data () {
    return {
      loading:false,
      disableButton:false,
      showOTP:false,
      form:{
        memb_no:'',
        password: '',
        confirmpassword:'',
        agreedToTerms: false,
        id_no : '',
        phone_no: '',
        otp:'',
      },      
      emailErrors: [],
      idNoErrors: [],
      phoneNoErrors: [],
      membNoErrors: [],
      passwordErrors: [],
      confirmPasswordErrors :[],
      agreedToTermsErrors: [],
      otpErrors: [],
      memberData:{},
      otp_no:'',
      config: {
        size: 80,
        duration: 1500,
      },
      spinnersColor: "#e60000",
      currentDuration: 1500,
      sliderDuration: {
        min: 1000,
        max: 2000,
      },
    }
  },
  computed: {
    speed () {
      return this.sliderDuration.min + this.sliderDuration.max - this.currentDuration
    },
    formReady () {
      return !this.membNoErrors.length  && !this.passwordErrors.length  && !this.idNoErrors.length  && !this.phoneNoErrors.length  && !this.confirmPasswordErrors.length  && !this.agreedToTermsErrors.length && !this.otpErrors.length
    },
  },
  methods: {
    checklength(){
      this.passwordErrors = this.form.password.length != 4 ? ['Enter four digit PIN'] : []
      if(!this.passwordErrors.length){
        this.passwordErrors = /^\d+$/.test(this.form.password) ? [] : ['Pin should countain digits only']
      }     
    },
    onsubmit () {
      this.membNoErrors = this.form.memb_no ? [] : ['Member No. field is required']
      this.passwordErrors = this.form.password ? [] : ['PIN is required']
      this.idNoErrors = this.form.id_no ? [] : ['ID No. is required']
      this.phoneNoErrors = this.form.phone_no ? [] : ['Phone No. is required']
      this.confirmPasswordErrors = this.form.confirmpassword ? [] : ['Confirm PIN field is required']
      this.agreedToTermsErrors = this.form.agreedToTerms ? [] : ['You must agree to the terms of use to continue']

      if (this.form.password != this.form.confirmpassword) {        
        this.passwordErrors = ['PINs Do not Match']
        this.confirmPasswordErrors =  ['PINs Do not Match']
      }      

      if (this.formReady) { 
        var self = this 
        self.loading = true;  
        self.disableButton = true;   
        axios.post(`${this.$apiUrl}RegUser/113`, this.form)
          .then(function (res) {
            self.loading = false;
            self.disableButton = false;  
            const response = res.data

            self.memberData = response.db_array;
            self.otp_no = response.otp;

            if (response.success === 1) {
              self.showOTP = true;
              self.otpErrors = ['Input OTP']
              self.showToast(`Successful! An OTP has been send to your Phone NO. Please input 4 digit OTP to complete application process`, {
                position: 'bottom-right',
                icon: "fa-check",
                duration: 10000,
              })
              setTimeout( () => self.showOTP = false, 300000);
            }

            if (response.success === 2) {
              self.membNoErrors = ['You are already a registered Portal or Mobile user']
              self.showToast(`You are already a registered Portal or Mobile user, use your mobile banking credentials to login or dial +254705951672 for PIN Reset assistance.`, {
                position: 'bottom-right',
                icon: "fa-times",
                duration: 300000,
              })
            } 

            if (response.success === 3) {
              self.membNoErrors = ['Account Not Found!']
              self.idNoErrors = ['Account Not Found!']
              self.phoneNoErrors = ['Account Not Found!']
              self.showToast(`Account Not Found! Confirm Your Member No, ID No, and Phone NO`, {
                position: 'bottom-right',
                icon: "fa-times",
                duration: 10000,
              })
            }

          })
          .catch(function (error) {
            console.log(error)
        })
      }
    },
    nameKeydown(e) {
      if (/^\W$/.test(e.key)) {
        e.preventDefault();
      }
  },
  validatephone() {  
    if ( (!/^\d{10}$/.test(this.form.phone_no))) {
      this.phoneNoErrors = 'Write a valid Phone Number'
    } 
    else {
      this.phoneNoErrors = ''
    }
  },
  submitFinal(){
      this.otpErrors = this.form.otp ? [] : ['OTP field field is required']
      if (this.form.otp != this.otp_no) {
        this.otpErrors = ['OTP does not match the one sent']
      }
      if (this.formReady) {

        const finalData = {
          formdata: this.form,
          db_array: this.memberData
        }

        var self = this  
        self.loading = true;
        self.disableButton = true;      
        axios.post(`${this.$apiUrl}RegUserFinal`, finalData)
        .then(function (res) {
          const response = res.data
          self.loading = false;
          self.disableButton = false;  
          if (response.success === 1) { 
            self.showToast(`Successful! Your application has been recieved you will recieve an sms confirmation once approved`, {
                position: 'bottom-right',
                icon: "fa-check",
                duration: 2500,
            })
            self.$router.push({name: "login" }); 
          }
        })
        .catch(function (error) {
            console.log(error)
        })
      }
    }
  }
}
</script>

<style lang="scss">
.myspinner {
  position: fixed;
  top: 40%;
  left: 22%;
  z-index: 999;
}

@media (max-width: 767px) {
  .myspinner {
    position: fixed;
    top: 38%;
    left: 40%;
    z-index: 999;
  }
}
</style>
